const styleSheet = () => ({
  container: {
    display: 'inline-block',
    width: 'max-content',
  },
  pill: {
    height: '24px',
    paddingTop: '8px',
    paddingBottom: '8px',
    paddingLeft: '11px',
    paddingRight: (props: any) => (props.groupCount ? '2.5px' : '11px'),
    border: (props: any) => (props.border ? props.border : '1px solid #E6EFFC'),
    borderRadius: '15.5px',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    backgroundColor: (props: any) =>
      props.backgroundColor ? props.backgroundColor : '#E6EFFC',
  },
  pillText: {
    height: '12px',
    color: (props: any) => (props.textColor ? props.textColor : '#085FE5'),
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '12px',
    display: 'flex',
  },
  groupCount: {
    display: 'flex',
    height: '18px',
    width: '18px',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
    alignSelf: '',
    marginLeft: '9px',
    color: (props: any) => (props.textColor ? props.textColor : '#085FE5'),
    backgroundColor: '#fff',
    border: '1px solid #fff',
  },
  groupCountText: {
    height: '12px',
    width: '7px',
    color: (props: any) => (props.textColor ? props.textColor : '#085FE5'),
    fontFamily: "'Museo Sans', sans-serif",
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '12px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
});

export default styleSheet;
